import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import "./poster.style.scss";
import { axios } from "../../lib/constants/api";

const metaLabelMap = {
  machine_type: "تیپ",
  post_title: "نام دستگاه",
  company: "شرکت سازنده",
  model: "مدل",
  year_of_manufacturing: "سال ساخت",
  made_in: "کشور سازنده",
  controller: "کنترلر",
  controller_model: "مدل کنترلر",
  chip_conveyor: "سفاله کش",
  turret_type: "نوع تارت",
  number_of_turret_tools: "تعداد ابزار تارت",
  turret_engine_type: "نوع موتور تارت",
  tailstock: "مرغک",
  lunette: "لینت",
  chuck_size: "قطر سه نظام (میلی متر)",
  machining_diameter: "قطر ماشین کاری (میلی متر)",
  turning_diameter: "قطر قابل گردش (میلی متر)",
  machining_length: "طول قابل تراشکاری (میلی متر)",
  have_c_axis: "محور c",
  have_y_axis: "محور y",
  spindle_bore_type: "گلو اسپیندل",
  spindle_bore_diameter: "قطر گلویی (میلی متر)",
  spindle_type: "نوع اسپیندل",
  max_spindle_speed: "حداکثر دور اسپیندل (RPM)",
  table_dimensions: "ابعاد میز (میلی متر)",
  number_of_axes: "تعداد محور",
  tool_changer_type: "نوع تول چنجر",
  number_of_tools: "تعداد ابزار",
  tool_std: "استاندارد ابزار",
  tool_size: "اندازه ابزار",
  axes_mechanism: "مکانیزم محوره",
  "x-axis-travel": "کورس محور X (میلی متر)",
  "y-axis-travel": "کورس محور Y (میلی متر)",
  "z-axis-travel": "کورس محور Z (میلی متر)",
  "w-axis-travel": "کورس محور W (میلی متر)",
  supplementary_details: "توضیحات تکمیلی",
};

export const PosterOldComponent: React.FC = () => {
  const { productId } = useParams<{ productId: string }>();
  const [product, setProduct] = useState<any>(null);

  useEffect(() => {
    let isMounted = true;
    
    const handleFetchProduct = async () => {
      try {
        const fetchedProduct = await axios.get(`/products/${productId}`);
        if (isMounted && fetchedProduct.data) {
          setProduct(fetchedProduct.data);
        }
      } catch (error) {
        if (isMounted) {
          console.error('Error fetching product:', error);
        }
      }
    };
    
    if (productId) {
      handleFetchProduct();
    }
    
    return () => {
      isMounted = false;
    };
  }, [productId]);

  const posterImage =
    (product && product.images && product.images[0].src) || undefined;

  const getProductMeta = () => {
    if (!product) return [];

    const commonMeta = ["made_in", "controller", "year_of_manufacturing"];
    const isMachineEquals = (machineName: string) =>
      product.categories?.some(({ name }: { name: string }) => name.includes(machineName));

    const specialMeta = isMachineEquals("تراش")
      ? ["chuck_size", "machining_diameter", "max_spindle_speed"]
      : ["x-axis-travel", "y-axis-travel", "z-axis-travel", "table_dimensions"];

    const posterAttrs = product.meta_data.filter(({ key }) =>
      [...specialMeta, ...commonMeta].includes(key)
    );

    return posterAttrs;
  };

  const getArmanAttr = () => {
    if (!product) return;

    const armanAttr = product.attributes.find(
      ({ name }) => name === "شناسه آرمان"
    );
    const attr =
      armanAttr &&
      armanAttr.options[0] &&
      `شناسه دستگاه: ${armanAttr.options[0]}`;
    return attr || "";
  };
  return (
    product && (
      <div className="poster-container">
        <div className="poster-title">{product.name}</div>
        <div className="body">
          <span className="arman-id">{getArmanAttr()}</span>
          <img
            className="poster-image"
            src={
              posterImage ||
              "https://files.armancnc.com/api/products/proxy-image?imageUrl=https://armancnc.com/wp-content/uploads/2023/08/arman-final-logo-1-2048x532-1.png"
            }
            alt=""
          />
          <table className="poster-attrs">
            {getProductMeta().map(({ value, key }, index) => (
              <tr key={`${key}-${index}`}>
                <td>{value || ""}</td>
                <td style={{ width: "max-content" }}>
                  {metaLabelMap[key].replace(/\(میلی متر\)/g, "")}
                </td>
              </tr>
            ))}
          </table>
        </div>
      </div>
    )
  );
};
